var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flat-button',{staticClass:"bg-lunar fixed bottom-0 right-0 z-999999 mb-12 mr-4",attrs:{"type":"large","dark":"","icon":"chevron-up"},on:{"click":_vm.scrollToTop}})
}
var staticRenderFns = []

export { render, staticRenderFns }